import { activeEvents } from './projection';
import type { ClinicalEvent } from './types';
export function deriveLaborState(events: ClinicalEvent[], encounterId: string, now = new Date().toISOString()) {
  const active = activeEvents(events)
    .filter((e) => e.encounter_id === encounterId && Date.parse(e.occurred_at) <= Date.parse(now))
    .sort((a, b) => Date.parse(a.occurred_at) - Date.parse(b.occurred_at) || a.sequence - b.sequence);
  let derived = 'Preadmission';
  let sourceId: string | undefined;
  for (const e of active) {
    const milestone = String(e.payload.milestone ?? '');
    const value =
      e.event_type === 'NOTE.ADMISSION'
        ? 'Admitted'
        : e.event_type === 'NOTE.DISCHARGE' || e.event_type === 'BIRTH.DISCHARGE'
          ? 'Discharged'
          : e.event_type === 'TRANSPORT'
            ? 'Transported'
            : e.event_type === 'PLACENTA'
              ? 'Fourth stage'
              : e.event_type === 'BIRTH'
                ? 'Third stage'
                : e.event_type === 'LABOR.PROGRESS' && e.payload.dilation_cm === 10
                  ? 'Second stage'
                  : e.event_type === 'LABOR.PROGRESS' && e.payload.active_labor === true
                    ? 'Active labor'
                    : e.event_type === 'MILESTONE'
                      ? (
                          {
                            ADMITTED: 'Admitted',
                            ACTIVE_LABOR: 'Active labor',
                            SECOND_STAGE: 'Second stage',
                            PUSHING_START: 'Second stage',
                            DISCHARGED: 'Discharged',
                            TRANSPORTED: 'Transported',
                          } as Record<string, string>
                        )[milestone]
                      : undefined;
    if (value) {
      derived = value;
      sourceId = e.id;
    }
  }
  const stated = active.filter((e) => e.event_type === 'LABOR.STATUS').at(-1);
  return {
    derived,
    sourceId,
    stated: stated?.payload.value,
    conflict:
      !!stated && sourceId !== undefined && String(stated.payload.value).toLowerCase() !== derived.toLowerCase(),
  };
}
